import { getAccentColor as getInaccessibleLightAccentColor } from './accentColor/themes/InaccessibleLight/alias';
import { getAccentColor as getLightAccentColor } from './accentColor/themes/Light/alias';
import { getBackgroundColor as getInaccessibleLightBackgroundColor } from './backgroundColor/themes/InaccessibleLight/alias';
import { getBackgroundColor as getLightBackgroundColor } from './backgroundColor/themes/Light/alias';
import { getBorderColor as getInaccessibleLightBorderColor } from './borderColor/themes/InaccessibleLight/alias';
import { getBorderColor as getLightBorderColor } from './borderColor/themes/Light/alias';
import { getColor as getInaccessibleLightColor } from './color/themes/InaccessibleLight/alias';
import { getColor as getLightColor } from './color/themes/Light/alias';
import { getOutlineColor as getInaccessibleLightOutlineColor } from './outlineColor/themes/InaccessibleLight/alias';
import { getOutlineColor as getLightOutlineColor } from './outlineColor/themes/Light/alias';
import { getTextDecorationColor as getInaccessibleLightTextDecorationColor } from './textDecorationColor/themes/InaccessibleLight/alias';
import { getTextDecorationColor as getLightTextDecorationColor } from './textDecorationColor/themes/Light/alias';
export function getAccentColor(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightAccentColor(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightAccentColor(transformer);
    }
    return getInaccessibleLightAccentColor(transformer);
}
export function getBackgroundColor(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightBackgroundColor(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightBackgroundColor(transformer);
    }
    return getInaccessibleLightBackgroundColor(transformer);
}
export function getBorderColor(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightBorderColor(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightBorderColor(transformer);
    }
    return getInaccessibleLightBorderColor(transformer);
}
export function getColor(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightColor(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightColor(transformer);
    }
    return getInaccessibleLightColor(transformer);
}
export function getOutlineColor(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightOutlineColor(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightOutlineColor(transformer);
    }
    return getInaccessibleLightOutlineColor(transformer);
}
export function getTextDecorationColor(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightTextDecorationColor(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightTextDecorationColor(transformer);
    }
    return getInaccessibleLightTextDecorationColor(transformer);
}
